import {
  ChangeDetectorRef,
  Component,
  effect,
  ElementRef,
  HostListener,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { CookieService } from "ngx-cookie";

import { CommonModule, DOCUMENT } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatMenuModule } from "@angular/material/menu";
import { DomSanitizer } from "@angular/platform-browser";
import {
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbModal,
  NgbTooltip,
} from "@ng-bootstrap/ng-bootstrap";
import { AvatarModule } from "ngx-avatars";
import { NgScrollbarModule } from "ngx-scrollbar";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { fromEvent, Subscription } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";
import { ModalLogoutComponent } from "src/app/layout/auth/modal-logout/modal-logout.component";
import {
  ADMIN_DOMAIN,
  COOKIE_PREFIX,
  IMG_PREFIX,
} from "src/environments/environment";
import swal from "sweetalert2";
import { CageBookingModalComponent } from "../..//layout/main/health-map-reports/cage-booking-modal/cage-booking-modal.component";
import { GroomingPlanModalComponent } from "../..//layout/main/health-map-reports/grooming-plan-modal/grooming-plan-modal.component";
import {
  API_URLS,
  AVATAR_BG_COLOR,
  AVATAR_FG_COLOR,
  DATEFORMATE,
  DEFAULT_IMAGE_PATH,
  FILE_PATH_CAGE,
  FILE_PATH_MENU,
  FILE_PATH_PLAN,
  MENU_ITEMS,
  PRODUCT_PATH,
  SCROLLBARS_OPTIONS,
} from "../../config/app.constants";
import { Globals } from "../../globals";
import { AuthService } from "../../shared/services/auth.service";
import { CartsService } from "../../shared/services/carts.service";
import { GlobalService } from "../../shared/services/global.service";
import { LoginService } from "../../shared/services/login.service";
import {
  GoogleAutocomplegteService,
  Maps,
} from "../services/google-autocomplegte.service";
import { HttpinterceptorService } from "../services/httpinterceptor.service";
import { SpinnerComponent2 } from "../spinners/spinner2.component";
import { Utils } from "../utils";
import { OutPostModalService } from "./outpost-list-modal/out-post-modal.service";

declare const $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    NgbTooltip,
    FormsModule,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    RouterLinkActive,
    NgbDropdownItem,
    MatButtonModule,
    MatMenuModule,
    NgScrollbarModule,
    AvatarModule,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    GroomingPlanModalComponent,
    CageBookingModalComponent,
    SpinnerComponent2,
    MatExpansionModule,
  ],
  providers: [Utils],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild("search")
  public searchElementRef: ElementRef;
  public place: google.maps.places.PlaceResult;

  isSticky$ = fromEvent(window, "scroll").pipe(
    map((x) => window.scrollY),
    distinctUntilChanged(),
    map((scrollTop: number) => scrollTop >= 66)
  );

  private subscription: Subscription;

  isMenuOpen: boolean = false;
  groomingPetDetail: any;
  groomingPlanDetail: any;
  showModal: boolean = false;

  boardingPetDetail: any;
  boardingPlanDetail: any;
  showBoardingModal: boolean = false;
  activeEditGroomingModal: boolean = false;
  activeEditBoardingModal: boolean = false;

  avatar_fg_color = AVATAR_FG_COLOR;
  avatar_bg_color = AVATAR_BG_COLOR;

  defaultImagePath = DEFAULT_IMAGE_PATH;

  // cart related constiable declaration
  cartDetails: any = [{ items: [] }];
  cartCount: number = 0;
  editCartUrl: string;

  userData: any = [];

  switchDetails: any = { switch_back: "" };

  scrollbarOptions = SCROLLBARS_OPTIONS;

  jwtHelper = new JwtHelperService();

  selectedOutpost: any = "";
  selectedOutpostId;
  outpostList = [];
  showOutpostModal: boolean = false;
  isSpinner = false;
  filter: any;
  isApiLoaded = false;
  lat: any;
  long: any;
  options: any = {
    types: [],
    componentRestrictions: { country: "US" },
  };
  locationText;
  formattedAddress = "";
  isAddressText = false;
  menus = [];
  isOpenMenu = false;
  hovered: boolean = false;
  leftProperty: string = "auto";
  rightProperty: string = "auto";

  submenuLeft: any;
  submenuRight: any;
  isShowDropdown: boolean = false;
  menuItems = MENU_ITEMS;
  format = DATEFORMATE;
  filePath = FILE_PATH_PLAN;
  boardingFilePath = FILE_PATH_CAGE;
  productImagePath = PRODUCT_PATH;
  imgPrefixLink = IMG_PREFIX;
  menuIcon = FILE_PATH_MENU;
  isUserMenuOpen: boolean = false;
  isCartMenuOpen: boolean;

  constructor(
    private http: HttpinterceptorService,
    private globals: Globals,
    private auth: AuthService,
    public router: Router,
    public cartsService: CartsService,
    public loginService: LoginService,
    public cookieService: CookieService,
    private cdr: ChangeDetectorRef,
    private outpostModalService: OutPostModalService,
    private globalService: GlobalService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private modalService: NgbModal,
    private ngZone: NgZone,
    private googleAutoCompleteService: GoogleAutocomplegteService,
    public utils: Utils,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
      for (const ind in this.outpostList) {
        if (this.outpostList[ind].id === this.selectedOutpostId) {
          this.selectedOutpost = this.outpostList[ind].title;
        }
      }
    }

    effect(() => {
      const el = this.outpostModalService.activatedOutpostId();
      if (localStorage.getItem("selectedOutpostId")) {
        this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
        for (const ind in this.outpostList) {
          if (this.outpostList[ind].id === this.selectedOutpostId) {
            this.selectedOutpost = this.outpostList[ind].title;
          }
        }
      } else if (el) {
        this.selectedOutpostId = el.id;
        this.selectedOutpost =
          el.title + (el.distance ? "  (" + `${el.distance} mi` + ")" : "");
      } else {
        this.getOutpostList();
      }
    });

    // this.outpostModalService.currentOutpostId.subscribe((el: any) => {
    //   this.selectedOutpostId = el.id;
    //   if (this.selectedOutpostId) {
    //     for (const ind in this.outpostList) {
    //       if (this.outpostList[ind].id === this.selectedOutpostId) {
    //         if (el.distance) {
    //           this.selectedOutpost =
    //             this.outpostList[ind].title + "  (" + `${el.distance} mi` + ")";
    //         } else {
    //           this.selectedOutpost = this.outpostList[ind].title;
    //         }
    //       }
    //     }
    //   }
    // });

    // if (localStorage.getItem("selectedOutpostId")) {
    //   this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    //   for (const ind in this.outpostList) {
    //     if (this.outpostList[ind].id === this.selectedOutpostId) {
    //       this.selectedOutpost = this.outpostList[ind].title;
    //     }
    //   }
    // }

    if (!this.selectedOutpostId) {
      this.getOutpostList();
    } else {
      if (navigator.geolocation) {
        if (!localStorage.getItem("lat") && !localStorage.getItem("long")) {
          navigator.geolocation.getCurrentPosition(
            (position: any) => {
              if (position) {
                localStorage.setItem("lat", position.coords.latitude);
                localStorage.setItem("long", position.coords.longitude);

                this.http
                  .post(
                    API_URLS.GET_OUT_POST_LIST,
                    {
                      lat: position.coords.latitude,
                      long: position.coords.longitude,
                    },
                    false
                  )
                  .subscribe(
                    (res) => {
                      this.outpostList = res.data.data;
                      if (
                        position.coords.latitude &&
                        position.coords.longitude
                      ) {
                        for (const outpost in this.outpostList) {
                          this.outpostList[outpost].distance = Math.round(
                            this.outpostList[outpost].distance
                          );
                          if (
                            this.outpostList[outpost].id ===
                            this.selectedOutpostId
                          ) {
                            if (this.outpostList[outpost].distance) {
                              this.selectedOutpost =
                                this.outpostList[outpost].title +
                                "  (" +
                                `${this.outpostList[outpost].distance} mi` +
                                ")";
                            } else {
                              this.selectedOutpost =
                                this.outpostList[outpost].title;
                            }
                            break;
                          }
                        }
                      }
                    },
                    (error) => {}
                  );
              }
            },
            (error) => {
              this.http.post(API_URLS.GET_OUT_POST_LIST, {}, false).subscribe(
                (res) => {
                  this.outpostList = res.data.data;
                  for (const outpost of this.outpostList) {
                    if (outpost.id === this.selectedOutpostId) {
                      this.selectedOutpost = outpost.title;
                      break;
                    }
                  }
                },
                (error) => {}
              );
            }
          );
        } else {
          let lat, long;
          if (
            localStorage.getItem("draggedLat") &&
            localStorage.getItem("draggedLng")
          ) {
            lat = localStorage.getItem("draggedLat");
            long = localStorage.getItem("draggedLng");
          } else if (
            localStorage.getItem("lat") &&
            localStorage.getItem("long")
          ) {
            lat = localStorage.getItem("lat");
            long = localStorage.getItem("long");
          }

          this.http
            .post(
              API_URLS.GET_OUT_POST_LIST,
              {
                lat: lat,
                long: long,
              },
              false
            )
            .subscribe(
              (res) => {
                this.outpostList = res.data.data;
                for (const outpost in this.outpostList) {
                  this.outpostList[outpost].distance = Math.round(
                    this.outpostList[outpost].distance
                  );
                  if (this.outpostList[outpost].id === this.selectedOutpostId) {
                    if (this.outpostList[outpost].distance) {
                      this.selectedOutpost =
                        this.outpostList[outpost].title +
                        "  (" +
                        `${this.outpostList[outpost].distance} mi` +
                        ")";
                    } else {
                      this.selectedOutpost = this.outpostList[outpost].title;
                    }
                    break;
                  }
                }
              },
              (error) => {}
            );
        }
      }
    }
    this.cartCount = this.cartsService.getCartCount();
    this.cartDetails = JSON.parse(this.cartsService.getCartItems());
    if (!jQuery.isEmptyObject(globals.currentUser)) {
      this.userData.push(this.globals.currentUser);
      this.switchDetails.switch_back = this.globals.currentUser.switch
        ? this.globals.currentUser.switch_back
        : "";
    }

    if (
      globals.currentUser ||
      (globals.currentUser && globals.currentUser.switch)
    ) {
      cartsService.getCartWithApi();
    }
  }

  @HostListener("keyup.enter")
  onEnter() {
    this.cdr.detectChanges();
  }
  redirectPage($page) {
    $(".login-modal").modal("hide");
    this.router.navigate($page);
  }

  ngOnInit() {
    this.googleAutoCompleteService.api.then((maps) => {
      this.initAutocomplete(maps);
    });

    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          const url = event["url"].split("/");
          if (url.includes("edit")) {
            this.editCartUrl = "plans/" + url[3];
          } else {
            this.editCartUrl = "";
          }
        }
      },
      () => {
        this.editCartUrl = "";
      }
    );
    this.subscription = this.cartsService.cartItemsCount.subscribe(
      (cartItemsCount) => {
        this.cartCount = cartItemsCount;
      }
    );
    this.subscription = this.cartsService.cartItems.subscribe((cartItems) => {
      this.cartDetails = JSON.parse(cartItems);
    });
    this.getMenuItems();
    // this.addCustomScroll();
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  getMenuItems() {
    this.http
      .post(API_URLS.GET_MENUS, { out_post_id: this.selectedOutpostId }, false)
      .subscribe((response) => {
        if (response.data) {
          this.menus = response.data;

          for (const menu of this.menus) {
            for (const submenu of menu?.submenu) {
              submenu.description = this.sanitizer.bypassSecurityTrustHtml(
                submenu.description
              );
            }
          }
        }
      });
  }

  onProductSelect(categoryId) {
    this.router.navigate(["/product/list", categoryId]);
    this.resetMenuArray();
  }

  onPlanSelect(plan, subMenuPath?) {
    let route;
    if (plan.multiple_pet_type && subMenuPath) {
      route = `${plan.path}/${subMenuPath}`;
      this.router.navigate([route]);
    }

    if (!plan.multiple_pet_type) {
      route = `${plan.path}`;
      this.router.navigate([route]);
    }
    this.resetMenuArray();
  }

  logout() {
    const modalRef = this.modalService.open(ModalLogoutComponent, {
      size: "md",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.closeLogout.subscribe(
      (response) => {
        if (response) {
          this.http.post(API_URLS.LOGOUT, {}, true).subscribe((resp) => {
            if (resp) {
              this.loginService.userData = [];
              this.auth.logoutUser();
              this.cartsService.emptyCart(true);
              this.globals.currentUser = null;
              this.auth.recordingScriptBeforeLogout();
              this.auth.initRecordingScript();
              this.auth.recordingScriptAfterLogin();
              this.router.navigate(["/"]);
            }
          });
        }
        modalRef.close();
      },
      (reason) => {}
    );
  }

  removeCartItem(itemId) {
    if (itemId) {
      this.cartsService.removeItemApi(itemId);
      if (this.editCartUrl != "" && this.editCartUrl != undefined) {
        this.router.navigate([this.editCartUrl]);
      }
    }
  }

  editCartItem(cartData, cartModel, service) {
    cartModel.close();
    switch (service) {
      case "subscription":
        const cartUniqueId = cartData.cart_unique_id
          ? cartData.cart_unique_id
          : cartData.id;

        this.router.navigate([
          `plans/edit/${cartData.plan.slug}/${cartUniqueId}`,
        ]);

        break;

      case "grooming":
        this.activeEditGroomingModal = true;
        this.openGroomingPlanModal(cartData);
        break;

      case "boarding":
        this.activeEditBoardingModal = true;
        this.openBoardingModal(cartData);
        break;
    }
  }

  openGroomingPlanModal(planDetail) {
    this.groomingPetDetail = {
      id: planDetail.pet_id,
      pet_size_id: planDetail.pet_size_id ? planDetail.pet_size_id : null,
    };
    this.groomingPlanDetail = {
      id: planDetail.grooming_plan_id,
      extraServices: planDetail.addon_detail,
      groomingDate: planDetail.groomingDate,
      groomer: planDetail.groomer_detail,
      cart_id: planDetail.id,
      is_advance_grooming_amount: planDetail.is_advance_grooming_amount,
      advance_payment: planDetail.advance_payment,
      planEditMode: true,
    };
    this.showModal = true;
  }

  closeGroomingPlanModal(flag) {
    this.groomingPetDetail = null;
    this.groomingPlanDetail = null;
    this.showModal = false;
    this.activeEditGroomingModal = false;
  }

  openBoardingModal(boardingDetail) {
    this.boardingPetDetail = boardingDetail.pets[0];
    this.boardingPlanDetail = {
      id: boardingDetail.cage_type_id,
      booking_from: boardingDetail.booking_from,
      booking_to: boardingDetail.booking_to,
      inward_time: boardingDetail.inward_time,
      outward_time: boardingDetail.outward_time,
      is_advance_booking_amount: boardingDetail.is_advance_booking_amount,
      advance_payment: boardingDetail.advance_payment,
      cart_id: boardingDetail.id,
      planEditMode: true,
    };
    this.showBoardingModal = true;
  }

  closeBoardingPlanModal(flag) {
    if (flag) {
      this.ngOnInit();
    }
    this.boardingPetDetail = null;
    this.boardingPlanDetail = null;
    this.showBoardingModal = false;
    this.activeEditBoardingModal = false;
  }

  cartMenu() {
    this.getCartData();
  }

  getCartData() {
    if (this.cartDetails) {
      for (const index in this.cartDetails.items) {
        if (
          Object.prototype.hasOwnProperty.call(this.cartDetails.items, index)
        ) {
          if (this.cartDetails.items[index].pet_info) {
            if (
              this.cartDetails.items[index].pet_info &&
              typeof this.cartDetails.items[index].pet_info === "string"
            ) {
              this.cartDetails.items[index].pet_info = JSON.parse(
                this.cartDetails.items[index].pet_info
              );
            } else {
              this.cartDetails.items[index].pet_info =
                this.cartDetails.items[index].pet_info;
            }
            if (this.cartDetails.items[index].item_type == "subscription") {
              let cart_price =
                this.cartDetails.items[index].plan_level.monthly_price;
              for (const key in this.cartDetails.items[index].extra_services) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    this.cartDetails.items[index].extra_services,
                    key
                  )
                ) {
                  cart_price =
                    cart_price +
                    this.cartDetails.items[index].extra_services[key]
                      .monthly_price;
                }
              }
              this.cartDetails.items[index]["cart_price"] = cart_price;
            }
          }
        }
      }
    }
  }

  CheckUserAuthentication(cart) {
    cart.close();
    if (this.cartDetails.length !== 0) {
      const checkUserAuthentication = localStorage.getItem(
        `${COOKIE_PREFIX}_token`
      );
      if (checkUserAuthentication) {
        this.router.navigate(["checkout"]);
      } else {
        this.loginService.openLoginModal("login", "/checkout");
      }
    }
    this.isCartMenuOpen = false;
    this.document.body.classList.remove("body-overflow");
  }

  backToDashboard() {
    this.http
      .post(API_URLS.BACK_TO_ADMIN_DASHBOARD, {}, false)
      .subscribe((res) => {
        if (res.data && res.data.token) {
          localStorage.setItem("switch", "false");
          this.cartsService.emptyCart(true);
          this.cookieService.put("token", res.data.token);
          this.cookieService.remove(`${COOKIE_PREFIX}_token`);
          sessionStorage.removeItem(`${COOKIE_PREFIX}_token`);
          const user = this.jwtHelper.decodeToken(res.data.token);
          this.cookieService.putObject("current_user", user);
          window.location.replace(ADMIN_DOMAIN + "/users");
        }
      });
  }

  onMenuItemClick(path) {
    this.router.navigate([path]);
    this.isMenuOpen = false;
    this.document.body.classList.remove("body-overflow");
  }

  getTotalCartPrice() {
    let totalPriceToShow = 0;
    if (this.cartDetails && this.cartDetails != null) {
      for (const index in this.cartDetails.items) {
        if (
          Object.prototype.hasOwnProperty.call(this.cartDetails.items, index)
        ) {
          let itemType = this.cartDetails.items[index].item_type;
          if (itemType == "grooming" || itemType == "boarding") {
            totalPriceToShow += this.cartDetails.items[index].advance_payment;
          } else if (itemType == "subscription") {
            totalPriceToShow += this.getPriceTotal(
              this.cartDetails.items[index].plan_level.monthly_price,
              this.cartDetails.items[index].extra_services
            );
          } else {
            totalPriceToShow += this.cartDetails.items[index].monthly_price;
          }
        }
      }
      return totalPriceToShow;
    }
  }

  getPriceTotal(planPrice, services) {
    let totalPrice = 0;
    for (const index in services) {
      if (Object.prototype.hasOwnProperty.call(services, index)) {
        totalPrice = totalPrice + services[index].monthly_price;
      }
    }
    return (totalPrice = planPrice + totalPrice);
  }

  onSelect() {
    this.searchElementRef.nativeElement.value = "";
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    $(".outpost-modal").modal("show");
    Utils.disableBodyScroll();
    this.headeroutpostData();
  }
  getOutpostList() {
    this.http.post(API_URLS.GET_OUT_POST_LIST, {}, false).subscribe(
      (res) => {
        this.outpostList = res.data.data;
        for (const ind in this.outpostList) {
          if (this.outpostList[ind].is_default) {
            this.selectedOutpost = this.outpostList[ind].title;
            this.selectedOutpostId = this.outpostList[ind].id;
            this.storeOutpostIdInLocalStorage();
          }
        }
      },
      (error) => {}
    );
  }
  storeOutpostIdInLocalStorage() {
    if (localStorage.getItem("selectedOutpostId")) {
      localStorage.removeItem("selectedOutpostId");
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    } else {
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    }
  }

  headeroutpostData() {
    let lat;
    let long;
    if (
      localStorage.getItem("draggedLat") &&
      localStorage.getItem("draggedLng")
    ) {
      lat = localStorage.getItem("draggedLat");
      long = localStorage.getItem("draggedLng");
    } else if (localStorage.getItem("lat") && localStorage.getItem("long")) {
      lat = localStorage.getItem("lat");
      long = localStorage.getItem("long");
    }
    const queryParmams: any = {
      lat: lat,
      long: long,
      search_key: this.filter,
    };
    this.http.post(API_URLS.GET_OUT_POST_LIST, queryParmams, false).subscribe(
      (res) => {
        this.outpostList = res.data.data;
        // if (lat && long) {
        for (const outpost in this.outpostList) {
          const title = this.outpostList[outpost].title.split(" ");
          if (title.length == 1) {
            this.outpostList[outpost].icon = title
              .toString()
              .substring(0, 2)
              .toUpperCase();
          } else {
            const splitTitle = title[0] + " " + title[title.length - 1];
            const matches = splitTitle.match(/\b(\w)/g);
            this.outpostList[outpost].icon = matches.join("").toUpperCase();
          }
          this.outpostList[outpost].distance = Math.round(
            this.outpostList[outpost].distance
          );
          if (this.outpostList[outpost].id === this.selectedOutpostId) {
            if (this.outpostList[outpost].distance) {
              this.selectedOutpost =
                this.outpostList[outpost].title +
                "  (" +
                `${this.outpostList[outpost].distance} mi` +
                ")";
            } else {
              this.selectedOutpost = this.outpostList[outpost].title;
            }
          }
        }
      },
      (error) => {}
    );
  }
  searchEnable() {
    if ((this.filter && this.filter.length >= 3) || !this.filter) {
      this.headeroutpostData();
    }
  }
  selectCenter(outpostData) {
    this.selectedOutpost = outpostData.title;
    this.selectedOutpostId = outpostData.id;

    this.storeOutpostIdInLocalStorage();
    this.headeroutpostData();

    setTimeout(() => {
      this.outpostModalService.getCurrentPlanData(true);
      this.outpostModalService.getCurrentBoardServiceData(true);
      this.outpostModalService.getCurrentGroomingServiceData(true);
      // this.outpostModalService.getCheckoutData(true);
    }, 100);
    $(".outpost-modal").modal("hide");
    this.closeModal();
  }
  getCurrentlocation() {
    if (!(localStorage.getItem("lat") && localStorage.getItem("long"))) {
      swal.fire({
        text: "We are unable to fetch your current location. please enable your browser Location.",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      });
    } else {
      this.searchElementRef.nativeElement.value = "";
      this.lat = localStorage.getItem("lat");
      this.long = localStorage.getItem("long");

      localStorage.setItem("draggedLat", this.lat);
      localStorage.setItem("draggedLng", this.long);

      const queryParmams: any = {
        lat: this.lat,
        long: this.long,
      };
      this.http.post(API_URLS.GET_OUT_POST_LIST, queryParmams, false).subscribe(
        (res) => {
          this.outpostList = res.data.data;
          for (const outpost in this.outpostList) {
            const title = this.outpostList[outpost].title.split(" ");
            if (title.length == 1) {
              this.outpostList[outpost].icon = title
                .toString()
                .substring(0, 2)
                .toUpperCase();
            } else {
              const splitTitle = title[0] + " " + title[title.length - 1];
              const matches = splitTitle.match(/\b(\w)/g);
              this.outpostList[outpost].icon = matches.join("").toUpperCase();
            }
            this.outpostList[outpost].distance = Math.round(
              this.outpostList[outpost].distance
            );
            if (this.outpostList[outpost].id === this.selectedOutpostId) {
              if (this.outpostList[outpost].distance) {
                this.selectedOutpost =
                  this.outpostList[outpost].title +
                  "  (" +
                  `${this.outpostList[outpost].distance} mi` +
                  ")";
              } else {
                this.selectedOutpost = this.outpostList[outpost].title;
              }
            }
          }
        },
        (error) => {}
      );
    }
  }
  onKey(event) {
    let autocomplete_results = this.document.querySelector(".pac-container");
    if (autocomplete_results) {
      let pac_items = autocomplete_results.querySelectorAll(".pac-item");

      if (pac_items.length > 0) {
        this.isAddressText = true;

        this.locationText = pac_items[0].textContent;
      } else {
        this.isAddressText = false;
        this.locationText = "";
      }
    }
  }

  onKeyTab(event) {
    if (this.isAddressText && this.locationText) {
      setTimeout(() => {
        this.searchElementRef.nativeElement.value = this.locationText;
      }, 0);
    } else if (this.formattedAddress) {
      setTimeout(() => {
        this.searchElementRef.nativeElement.value = this.formattedAddress;
      }, 0);
    } else {
      setTimeout(() => {
        this.searchElementRef.nativeElement.value = "";
      }, 0);
    }
    this.headeroutpostData();
  }
  // goToCage(boarding) {
  //   this.router.navigate([boarding.path]);
  //   this.globalService.getCurrentBoardServiceData(boarding);
  // }
  openMenu(header) {
    header.isOpenMenu = !header.isOpenMenu;
  }
  openExpansionPanel(plan) {
    for (const menu of this.menus) {
      for (const submenu of menu?.submenu) {
        submenu.isExpansionOpen = false;
        if (menu?.title === "Products") {
          if (plan.product_cat_id == submenu.product_cat_id) {
            submenu.isExpansionOpen = true;
          }
        } else {
          if (plan.plan_id == submenu.plan_id) {
            submenu.isExpansionOpen = true;
          }
        }
      }
    }
  }
  resetMenuArray() {
    for (const menu of this.menus) {
      for (const submenu of menu?.submenu) {
        submenu.isExpansionOpen = false;
      }
    }
  }
  addClassOnHover(menuItem) {
    for (const menu of this.menus) {
      for (const submenu of menu?.submenu) {
        submenu.isShowContent = false;
        if (menuItem?.title === submenu.title) {
          submenu.isShowContent = true;
        }
      }
    }
  }

  // Add body overflow class when mobile menu is open and remove on close
  clickOnMenuIcon() {
    this.isMenuOpen = !this.isMenuOpen;
    this.isUserMenuOpen = false;
    this.isCartMenuOpen = false;
    if (this.isMenuOpen) {
      this.document.body.classList.add("body-overflow");
    } else {
      this.document.body.classList.remove("body-overflow");
    }
  }

  // Reset the scroll position to the top
  resetScrollPosition(header, event: MouseEvent) {
    const scrollContainer = this.elementRef.nativeElement.querySelector(
      `.${(header?.title).replace(" ", "")}`
    );
    // Reset the scroll position to the top
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }

    for (const menu of this.menus) {
      if (header.title == menu.title) {
        for (const submenu of menu?.submenu) {
          submenu.isShowContent = false;
        }
      }
    }
    this.hovered = false;

    // this.calculateSubMenuPosition(event);
  }

  // calculate window size and make mega menu adjustable
  // calculateSubMenuPosition(event) {
  //   const hoveredElement = event.currentTarget as HTMLElement;
  //   const rect = hoveredElement.getBoundingClientRect();
  //   const getPos = (window.outerWidth * 55) / 100;

  //   if (rect.left < getPos) {
  //     this.submenuLeft = 0;
  //     this.submenuRight = "auto";
  //   } else {
  //     this.submenuRight = 0;
  //     this.submenuLeft = "auto";
  //   }
  //   this.submenuLeft = getPos;
  //   this.cdr.detectChanges();
  // }
  openDropdownMenu() {
    if (window.screen.width <= 767) {
      this.isUserMenuOpen = !this.isUserMenuOpen;
      this.isMenuOpen = false;
      this.isCartMenuOpen = false;
      if (this.isUserMenuOpen) {
        this.document.body.classList.add("body-overflow");
      } else {
        this.document.body.classList.remove("body-overflow");
      }
    }
  }
  onCartMenuClick() {
    if (window.screen.width <= 767) {
      this.isCartMenuOpen = !this.isCartMenuOpen;
      if (this.cartCount) {
        this.isMenuOpen = false;
      }
      this.isUserMenuOpen = false;
      if (this.isCartMenuOpen && this.cartCount) {
        this.document.body.classList.add("body-overflow");
      } else {
        this.document.body.classList.remove("body-overflow");
      }
    }
  }
  goToPage(route) {
    this.router.navigate([route]);
    this.document.body.classList.remove("body-overflow");
  }
  initAutocomplete(maps: Maps) {
    const options = {
      componentRestrictions: { country: "us" }, //  <== Country code name
    };

    let autocomplete = new maps.places.Autocomplete(
      this.searchElementRef.nativeElement,
      options
    );
    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        this.onPlaceChange(autocomplete.getPlace());
      });
    });
  }
  onPlaceChange(place: google.maps.places.PlaceResult) {
    this.formattedAddress = place.formatted_address;

    if (place && place.formatted_address) {
      this.isAddressText = false;

      (this.lat = place.geometry.location.lat()),
        (this.long = place.geometry.location.lng());
      localStorage.setItem("draggedLat", this.lat);
      localStorage.setItem("draggedLng", this.long);
    } else {
      this.isAddressText = true;

      let geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          address: this.locationText,
        },
        (results) => {
          (this.lat = results[0].geometry.location.lat()),
            (this.long = results[0].geometry.location.lng());
          localStorage.setItem("draggedLat", this.lat);
          localStorage.setItem("draggedLng", this.long);
        }
      );
      this.searchElementRef.nativeElement.value = this.locationText;
    }

    this.headeroutpostData();
  }
  closeModal() {
    Utils.enableBodyScroll();
  }
  // addCustomScroll() {
  //   const $scrollContainer = $(".scroll-container");
  //   const $scrollContent = $(".scroll-content");
  //   const $scrollbar = $(".scrollbar");
  //   const $thumb = $(".thumb");

  //   const contentHeight = $scrollContent[0].scrollHeight;
  //   const containerHeight = $scrollContainer.height();
  //   const thumbHeight = (containerHeight * containerHeight) / contentHeight;

  //   $thumb.height(thumbHeight);

  //   $scrollContent.on("scroll", function () {
  //     const scrollTop = $scrollContent.scrollTop();
  //     const scrollRatio = scrollTop / (contentHeight - containerHeight);
  //     const thumbTop = scrollRatio * (containerHeight - thumbHeight);

  //     $thumb.css({ top: thumbTop + "px" });
  //   });

  //   $thumb.on("mousedown", function (event) {
  //     const initialY = event.pageY;
  //     const initialThumbTop = parseInt($thumb.css("top"), 10);

  //     $(document).on("mousemove.thumb", function (event) {
  //       const deltaY = event.pageY - initialY;
  //       let newThumbTop = initialThumbTop + deltaY;

  //       newThumbTop = Math.max(0, newThumbTop);
  //       newThumbTop = Math.min(containerHeight - thumbHeight, newThumbTop);

  //       const scrollRatio = newThumbTop / (containerHeight - thumbHeight);
  //       const newScrollTop = scrollRatio * (contentHeight - containerHeight);

  //       $scrollContent.scrollTop(newScrollTop);
  //     });

  //     $(document).on("mouseup.thumb", function () {
  //       $(document).off(".thumb");
  //     });

  //     return false;
  //   });
  // }
}
